import { dashboardTours } from "../tours/dashboardTours";
import type { OnboardingStrategy } from "../onboardingTypes";

/**
 * Dashboard onboarding content.
 *
 * Selected when trainingType is NotSet, which is the state on every route
 * outside an open training. Before this existed the ternary in
 * useOnboardingStrategy fell through to the 360 strategy, so mounting the host
 * here would have started editor360StageA, failed to resolve its anchors, and
 * left that tour in abortedThisSession, suppressing the real 360 tour when the
 * author opened a training in the same session.
 *
 * Empty shortcutGroups is correct rather than unfinished: the shortcuts overlay
 * is bound inside the editor and none of the editor shortcuts apply here.
 */
export const OnboardingStrategyDashboard: OnboardingStrategy = {
  tours: dashboardTours,
  hints: [],
  shortcutGroups: [],
};
